import UFOSegment from '@atlassian/react-ufo/segment';
export default UFOSegment;